import { Box, Button, Divider } from '@mui/material';
import { Add as AddIcon } from '@mui/icons-material';
import { useStyles } from './styles/ActionBar.styles';
import { Selection } from './Tree/types';
import { useSelector } from 'react-redux';

import type { RoleUtils } from '@/types/permissions';
import type { RootState } from '@features/redux/store';

const CREATE_OPTIONS = [
    {
        name: 'Company',
        type: Selection.Company,
        checkRole: (role: RoleUtils) => role.companies.fullAccess,
    },
    {
        name: 'Reseller',
        type: Selection.Reseller,
        checkRole: (role: RoleUtils) => role.resellers.fullAccess,
    },
    {
        name: 'Location',
        type: Selection.Location,
        checkRole: (role: RoleUtils) => role.locations.fullAccess,
    },
] as const;

export const ActionBar = ({ onCreate }: { onCreate: (type: Selection) => void }) => {
    const classes = useStyles();

    const role = useSelector((state: RootState) => state.auth.Roles.role);

    const newHandler = (selectionType: Selection) => () => {
        onCreate(selectionType);
    };

    return (
        <Box className={classes.container}>
            {CREATE_OPTIONS.map(({ name, type, checkRole }) => {
                return (
                    <Button
                        variant='contained'
                        color='secondary'
                        size='small'
                        startIcon={<AddIcon fontSize={'small'} />}
                        key={`create-${type}`}
                        onClick={newHandler(type)}
                        disabled={!checkRole(role)}>
                        New {name}
                    </Button>
                );
            })}
        </Box>
    );
};
